import _extends from 'babel-runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { TreeNode } from 'rc-tree';

/**
 * SelectNode wrapped the tree node.
 * Let's use SelectNode instead of TreeNode
 * since TreeNode is so confuse here.
 */
var SelectNode = function SelectNode(props) {
  return React.createElement(TreeNode, props);
};

SelectNode.propTypes = _extends({}, TreeNode.propTypes, {
  value: PropTypes.string
});

// Let Tree trade as TreeNode to reuse this for performance saving.
SelectNode.isTreeNode = 1;

export default SelectNode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tree-select@2.1.1@rc-tree-select/es/SelectNode.js
// module id = 187
// module chunks = 0 1